import _onlyNumbers from './onlyNumbers';
export const onlyNumbers = _onlyNumbers;

import _maxLength from './maxLength';
export const maxLength = _maxLength;

import _minLength from './minLength';
export const minLength = _minLength;

import _email from './email';
export const email = _email;

import _phone from './phone';
export const phone = _phone;

import _equalsTo from './equalsTo';
export const equalsTo = _equalsTo;

import _isValid from './isValid';
export const isValid = _isValid;

import _url from './url';
export const url = _url;

import _cnpj from './cnpj';
export const cnpj = _cnpj;

import _isValidDate from './isValidDate';
export const isValidDate = _isValidDate;

import _maxValue from './maxValue';
export const maxValue = _maxValue;

import _cep from './cep';
export const cep = _cep;
